import { CommonModule } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectorRef, Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CartouchesService } from '../../../services/cartouches.service';

@Component({
  selector: 'app-commandes-sequencage-passees',
  imports: [CommonModule, FormsModule],
  templateUrl: './commandes-sequencage-passees.component.html',
  styleUrl: './commandes-sequencage-passees.component.scss',
})
export class CommandesSequencagePasseesComponent {
  protected cartouchesInput = '';
  protected commande = true;
  protected dateCommande = this.toInputDate(new Date());

  protected saving = false;
  protected success = '';
  protected error = '';

  constructor(
    private readonly cartouchesService: CartouchesService,
    private readonly cdr: ChangeDetectorRef
  ) {}

  protected async save(): Promise<void> {
    if (this.saving) {
      return;
    }

    const noms = this.parseCartoucheNoms(this.cartouchesInput);
    if (noms.length === 0) {
      this.error = 'Veuillez saisir au moins un nom de cartouche.';
      this.success = '';
      this.cdr.markForCheck();
      return;
    }

    this.saving = true;
    this.error = '';
    this.success = '';
    this.cdr.markForCheck();

    const today = this.toInputDate(new Date());
    const payload = {
      cartouche_noms: noms,
      sequencage_commande: this.commande,
      date_sequencage: this.commande ? (this.dateCommande || today) : null,
    };

    this.cartouchesService.updateSequencageBatch(payload).subscribe({
      next: (response) => {
        this.success = `${response.updated} cartouche(s) mise(s) à jour.`;
        this.saving = false;
        this.cdr.markForCheck();
      },
      error: (err: HttpErrorResponse) => {
        this.error = this.getErrorMessage(err);
        this.saving = false;
        this.cdr.markForCheck();
      },
    });
  }

  protected onCommandeChange(value: boolean): void {
    this.commande = value;
    if (this.commande && !this.dateCommande) {
      this.dateCommande = this.toInputDate(new Date());
    }
  }

  private parseCartoucheNoms(raw: string): string[] {
    return Array.from(
      new Set(
        raw
          .split(/\s+/)
          .map((value) => value.trim())
          .filter((value) => value.length > 0)
      )
    );
  }

  private toInputDate(d: Date): string {
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  private getErrorMessage(err: HttpErrorResponse): string {
    if (typeof err.error === 'string' && err.error.trim()) {
      return err.error;
    }
    if (err.error?.detail) {
      return String(err.error.detail);
    }
    if (err.error?.message) {
      return String(err.error.message);
    }
    return err.statusText || 'Erreur inconnue';
  }
}
